import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const formats = [
  "YYYY-MM-DDTHH:mm:ss.SSSZ",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-DD-MM HH:mm:ss",
  "YYYY-MM-DD",
  "DD MMM YYYY",
  "DD-MMM-YYYY",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
];

const parseDate = (date) => {
  if (!date || date === "-" || date === "NA") return null;

  let parsed = dayjs(date);

  if (!parsed.isValid()) {
    parsed = dayjs(date, formats, true);
  }

  return parsed.isValid() ? parsed : null;
};

export const formatDate = (date) => {
  const parsed = parseDate(date);
  return parsed ? parsed.format("DD-MMM-YYYY") : date;
};

export const formatDateTime = (value) => {
  if (!value || value === "-" || value === "NA") return "-";

  const formats = [
    "YYYY-DD-MM HH:mm:ss",
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    "YYYY-MM-DDTHH:mm:ss",
  ];

  for (const fmt of formats) {
    const parsed = dayjs(value, fmt, true);
    if (parsed.isValid()) {
      return parsed.format("DD-MMM-YYYY HH:mm:ss");
    }
  }

  return value;
};